import React, { useEffect, useState } from "react";
import { Typography,Avatar, Button, Flex, Input, Space, Table, Tag } from "antd";
import Title from "antd/es/typography/Title";
import { colors } from "../../../../../../constants/colors";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  dateObjToDispViewDate,
  timeObjToDispViewTimeWithSuffix,
  downloadUrl
} from "../../../../../../utils/utils";
import { getOffers } from "../../../../../../redux/services/offer/offerServices";
import { SearchOutlined } from "@ant-design/icons";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { getGiftCardTransactionAction } from "../../../../../../redux/services/wallet-info/walletInfoServices";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

const GiftCardTransactions = () => {
  /* i18n dependencies */
  const { t } = useTranslation("giftCardTransaction");
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { giftCardTransactions } = useSelector(
    (state) => state.walletTransactions
  );
  const [searchValue, setSearchValue] = useState("");
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: giftCardTransactions?.transactions?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  useEffect(() => {
    handleGetTableData();
  }, [searchValue, pagination]);

  const handleGetTableData = () => {
    const dataToBeSent = {
      page: pagination?.pageNo,
      limit: pagination?.pageSize,
      search: searchValue,
    };
    dispatch(getGiftCardTransactionAction(setLoading));
  };

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("giftCode"),
        dataIndex: "gift_card_token",
        key: "gift_card_token",
        render: (_, record) => <p>{record.gift_card_token}</p>,
      },
      {
        title: t("status"),
        dataIndex: "status",
        key: "status",
        render: (_, { status }) => (
          <Tag
            key={status}
            style={{
              background: status === "used"
                ? colors.lightPastelBlue
                : colors.lightTeal,
              color: status === "used" ? colors.electricBlue : colors.darkTeal,
            }}
            bordered={false}
          >
            {status?.toUpperCase()}
          </Tag>
        ),
      },

      {
        title: t("Price"),
        dataIndex: "price",
        key: "price",
        render: (_, record) => (
          <p>{record?.price + " " + record?.currency.toUpperCase()}</p>
        ),
      },
      {
        title: t("purchaseOn"),
        dataIndex: "transaction_date",
        key: "transaction_date",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.created_at, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("Expires On"),
        dataIndex: "expire_date_time",
        key: "expire_date_time",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.expire_date_time, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("Redeemed On"),
        dataIndex: "redeemed_at",
        key: "redeemed_at",
        render: (_, record) => (
          <p>{record?.redeemed_at ? dateObjToDispViewDate(record?.redeemed_at, "ddmmyyyy") : "-"}</p>
        ),
      },

      {
        title: t("Redeemed By"),
        dataIndex: "redeemed_at",
        key: "redeemed_at",
        render: (_, record) => (
          <p>
            {record?.redeem_user_id ? record?.redeem_user_id?.first_name &&
            record?.redeem_user_id?.last_name
              ? record?.redeem_user_id?.first_name +
                " " +
                record?.redeem_user_id?.last_name
              : record?.redeem_user_id?.email : "-"}
          </p>
        ),
      },
      {
        title: t("viewPdf"),
        key: "viewPdf",
        dataIndex: "viewPdf",
        align: "center",
        render: (_, record) => {
          return (
            <>
              {
                <Typography.Link
                  onClick={(e) => handleViewPdfDetails(e, record)}
                >
                  {t("view")}
                </Typography.Link>
              }
            </>
          );
        }
      }
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);

  const handleViewPdfDetails = (e, row) => {
    if (
      row?.invoice_url &&
      row?.invoice_url !== "" &&
      row?.invoice_url !== null &&
      row?.invoice_url !== undefined
    ) {
      downloadUrl(row?.invoice_url);
    } 
  }
  return (
    <>
      <div>
        <Flex vertical gap="2rem">
          <Flex align="center" justify="space-between">
            <Title level={2}>{t("Gift Card Transactions")}</Title>
          </Flex>
          <Table
            dataSource={giftCardTransactions?.data}
            columns={columns}
            pagination={paginationObj}
          />
        </Flex>
      </div>
    </>
  );
};

export default GiftCardTransactions;
